module.exports = __webpack_public_path__ + "media/images/front/banner_kyusyu_dental_show_1-c65732276c1a9a6aa4c5fbdc2e3faca7.jpg";